export default __webpack_public_path__ + "static/media/pdfLogo.9cdb5412.svg";